import { render, staticRenderFns } from "./PostHistory.vue?vue&type=template&id=c4057ec2&scoped=true"
import script from "./PostHistory.vue?vue&type=script&lang=js"
export * from "./PostHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4057ec2",
  null
  
)

export default component.exports